import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import getExtendedProperty from './getExtendedProperty';

const SOURCE_WELLKNOWN_FOLDER_TYPE_PROPERTY_NAME = 'SourceWellKnownFolderType';

let getSourceWellKnownFolderTypeProperty = (folderItem: BaseFolderType) =>
    parseInt(
        getExtendedProperty(folderItem, SOURCE_WELLKNOWN_FOLDER_TYPE_PROPERTY_NAME),
        10 /* radix */
    );

export default getSourceWellKnownFolderTypeProperty;
